import { useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"

export function AmazonRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate({ to: "/" })
  }, [navigate])

  return (
    <div>Redirecting...</div>
  )
}
